import { Component, OnInit } from '@angular/core';
import { PrescriptionService } from 'src/core/services/prescription.service';
import { DosageType } from 'src/interfaces/dosage-type';
import { Medicine } from 'src/interfaces/medicine';
import { UntypedFormBuilder, Validators } from "@angular/forms";
import { Observable } from 'rxjs';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { LoaderService } from 'src/core/services/loader.service';
import { Router } from '@angular/router';
import { Batch, BatchCreatePayload, BatchStatus } from 'src/interfaces/batch';
import { MatSelectChange } from '@angular/material/select';
import { MedicineDosagePackageType } from 'src/interfaces/medicine-dosage-package-type';

@Component({
    selector: 'core-batch-create',
    templateUrl: './batch-create.component.html',
    styleUrls: ['./batch-create.component.scss'],
    standalone: false
})
export class BatchCreateComponent implements OnInit {

  medicinePage: number = 1;
  minDate: Date;
  medicineLimit: number = 30;
  medicine: Medicine[] = [];
  dosageTypes: DosageType[] = [];
  batchStatuses: BatchStatus[] = [];
  selectedMedicine: Medicine | null = null;
  medicineDosageTypePackageTypes: MedicineDosagePackageType[] = [];

  batchDetailsForm = this.formBuilder.group({
    medicine: ['', Validators.required],
    quantity: ['', Validators.compose([Validators.required, Validators.min(1), Validators.max(1000)])],
    batchNumber: ['', Validators.compose([
      Validators.required,
      Validators.pattern(
        "^([A-Z]{3,10}[0-9]{3,10})$"
      )
    ])],
    statusId: ['', Validators.required],
    dosageTypeId: ['', Validators.required],
    packageTypeId: ['', Validators.required],
    additional_information: [''],
    expiryDate: ['', Validators.required]
  });

  filteredMedicine: Observable<Medicine[]>;
  isLoading: boolean = false;

  constructor(
    private prescriptionService: PrescriptionService,
    private formBuilder: UntypedFormBuilder,
    private loaderService: LoaderService,
    private _router: Router
   
  ) {
    this.minDate = new Date();
  }

  ngOnInit(): void {

    this
      .loaderService
      .isLoading
      .subscribe(isLoading => {
        this.isLoading = isLoading;
      });

    this
      .prescriptionService
      .getFormData(['batch_status'])
      .subscribe(data => {
        this.batchStatuses = data.batch_status;
      });

    this
      .batchDetailsForm
      .controls['medicine']
      .valueChanges
      .subscribe(value => {
        this.getMedicine(value);
      });

  }

  async getMedicine(value: string) {
    this.medicine = await this
      .prescriptionService
      .getMedicine(value, this.medicinePage, this.medicineLimit);
  }

  medicineSelected(event: MatAutocompleteSelectedEvent) {
    this.selectedMedicine = event.option.value;

    if (!this.selectedMedicine) return;

    this
      .batchDetailsForm
      .patchValue({
        medicine: this.selectedMedicine.name,
      });

    this.getMedicineDosageTypes(this.selectedMedicine.id);
  }


  getMedicineDosageTypes(medicineId: number) {

    this
      .prescriptionService
      .getMedicineDosageTypes(medicineId)
      .subscribe(dosageTypes => {
        this.dosageTypes = dosageTypes;
      });

  }

  getMedicineDosagePackageTypes(event: MatSelectChange) {
    const dosageTypeId = parseInt(event.value);
    if (!this.selectedMedicine) return;

    this
      .prescriptionService
      .getMedicineDosagePackageTypes(this.selectedMedicine.id, dosageTypeId)
      .subscribe(medicineDosagePackageTypes => {
        this.medicineDosageTypePackageTypes = medicineDosagePackageTypes;
      })
  }

  async submitData() {


    const payload: BatchCreatePayload = {
      quantity: this.batchDetailsForm.value.quantity,
      batch_status_id: this.batchDetailsForm.value.statusId,
      medicine_dosage_package_type_id: this.batchDetailsForm.value.packageTypeId,
      batch_number: this.batchDetailsForm.value.batchNumber,
      expiry_date: this.batchDetailsForm.value.expiryDate.toISOString(),
      additional_information: this.batchDetailsForm.value.additional_information
    }
    const batch: Batch | null = await this
      .prescriptionService
      .createBatch(payload);

    if (batch) {
      this._router
        .navigateByUrl('/', { skipLocationChange: true })
        .then(() => {
          this._router.navigate(['/portal/batches/create']);
        })
    }
  }

}
